// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__INFCj","Players":"Game_Players__uJMpH"};